// Polyfills
import "core-js";
// React
import React, { Fragment } from "react";
import ReactDOM from "react-dom";
// CSS
import "./assets/css/font-awesome.min.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/smartadmin-production.min.css";
import "./assets/css/smartadmin-production-plugins.min.css";
import "./assets/css/smartadmin-skins.min.css";
import "./assets/fonts/open-sans/OpenSans.css";
import "./assets/css/date-picker.css";
import "./assets/css/custom.css";
// Redux
import { Provider } from "react-redux";
// React Router Redux
import { Redirect, Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import store, { history } from "./config/store";
// Service worker
import registerServiceWorker from "./config/registerServiceWorker";
// Constants
import { BASE_URL } from "./config/constants";
// Ducks
import { fetchIsoCountries } from "./services/internationalization.ducks";
import { fetchLoginTranslations } from "./services/localization.ducks";
import { restoreToken, restoreClaims } from "./services/auth.ducks";
// Component
import Dashboard from "./scenes/Dashboard";
import Login from "./scenes/Login";
import PasswordChange from "./scenes/PasswordChange";
import ProfileChange from "./scenes/ProfileChange";
import OpenPayment from "./scenes/OpenPayment";
import SmartNotification from "./components/SmartNotification/SmartNotification";
import Spinner from "./components/Spinner";
// i18n
import "./config/translation/i18n";

store.dispatch(restoreToken());
store.dispatch(restoreClaims());
store.dispatch(fetchLoginTranslations());
store.dispatch(fetchIsoCountries());

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const { auth } = store.getState();

      if (!auth.token) {
        return (
          <Redirect
            to={{
              pathname: `${BASE_URL}/login`,
              state: { from: props.location }
            }}
          />
        );
      }
      return <Component {...props} />;
    }}
  />
);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <>
        <Spinner />
        <SmartNotification />
        <Switch>
          <Route
            exact
            path={`${BASE_URL}/login`}
            render={(props) => {
              const { auth } = store.getState();
              return auth.token ? (
                <Redirect to={`${BASE_URL}/dashboard`} />
              ) : (
                <Login
                  from={
                    props.location.state
                      ? props.location.state.from.pathname
                      : `${BASE_URL}/dashboard`
                  }
                />
              );
            }}
          />
          <PrivateRoute path={`${BASE_URL}/dashboard`} component={Dashboard} />
          <PrivateRoute path={`${BASE_URL}/one_time_password`} component={PasswordChange} />
          <PrivateRoute path={`${BASE_URL}/one_time_profile`} component={ProfileChange} />
          <PrivateRoute path={`${BASE_URL}/openPayment`} component={OpenPayment} />
          <Route path={`${BASE_URL}/`} render={() => <Redirect to={`${BASE_URL}/login`} />} />
        </Switch>
      </>
    </ConnectedRouter>
  </Provider>,
  document.getElementById(`root`)
);

registerServiceWorker();
